import { Divider } from '@outdoorsyco/bonfire';
import React from 'react';

import { ICard } from '@/redux/modules/creditCards';

import { PaymentMethodItem } from '../PaymentMethodItem/PaymentMethodItem';

type TPaymentMethodsListProps = {
  userCards: ICard[];
  refreshUserCards: () => void;
};

export const PaymentMethodsList = ({ userCards, refreshUserCards }: TPaymentMethodsListProps) => {
  return userCards.length ? (
    <div className="mt-5">
      {userCards.map(userCard => (
        <div key={userCard.id}>
          <PaymentMethodItem userCard={userCard} refreshUserCards={refreshUserCards} />
          <Divider className="my-6" />
        </div>
      ))}
    </div>
  ) : null;
};
